// https://cmsdev.cruisecode.com/BookingPlatform/GetDTDAssignmentList
export const GetDTDAssignmentList = [
    {
        CompanyName: 'Alaska X',
        TourInventoryID: 11754,
        TourInventoryTime: {
            Hours: 8,
            Minutes: 0,
            Seconds: 0,
            Milliseconds: 0,
            Ticks: 288000000000,
            Days: 0,
            TotalDays: 0.3333333333333333,
            TotalHours: 8,
            TotalMilliseconds: 28800000,
            TotalMinutes: 480,
            TotalSeconds: 28800,
        },
        TourInventoryAllocatedSeats: 10,
        TourTime: '08:00 AM',
        ShipName: 'Norwegian Jewel',
        TourName: 'Chilkoot Horseback Adventure',
        PreLim: 0,
        Final: null,
        ActualTotal: null,
        ActualAdults: null,
        ActualChildren: null,
        CruiseLineEscorts: null,
        Transportation: null,
        GuideName: null,
        GuideFullName: null,
        DockName: null,
        DTDAssignmentGuideVariableId: null,
        DTDAssignmentGuideId: null,
        PayingAdditionalGuests: 0,
        SpecialNotes: null,
        BookingFName: null,
        BookingLName: null,
        BookingAdults: 0,
        BookingChildren: 0,
        BookingEmail: null,
        BookingPhone: null,
        PartnerId: null,
        TotalBooked: null,
        IsClosed: false,
        IsOpen: false,
        MobleViewColumn: null,
        Total: null,
    },
    {
        CompanyName: 'Alaska X',
        TourInventoryID: 14846,
        TourInventoryTime: {
            Hours: 10,
            Minutes: 30,
            Seconds: 0,
            Milliseconds: 0,
            Ticks: 378000000000,
            Days: 0,
            TotalDays: 0.4375,
            TotalHours: 10.5,
            TotalMilliseconds: 37800000,
            TotalMinutes: 630,
            TotalSeconds: 37800,
        },
        TourInventoryAllocatedSeats: 10,
        TourTime: '10:30 AM',
        ShipName: 'Book Direct',
        TourName: 'Chilkoot Horseback Adventure',
        PreLim: 9,
        Final: 9,
        ActualTotal: null,
        ActualAdults: null,
        ActualChildren: null,
        CruiseLineEscorts: null,
        Transportation: null,
        GuideName: null,
        GuideFullName: null,
        DockName: null,
        DTDAssignmentGuideVariableId: null,
        DTDAssignmentGuideId: null,
        PayingAdditionalGuests: 0,
        SpecialNotes: null,
        BookingFName: null,
        BookingLName: null,
        BookingAdults: 0,
        BookingChildren: 0,
        BookingEmail: null,
        BookingPhone: null,
        PartnerId: null,
        TotalBooked: null,
        IsClosed: false,
        IsOpen: false,
        MobleViewColumn: null,
        Total: 9,
    },
    {
        CompanyName: 'Alaska X',
        TourInventoryID: 9250,
        TourInventoryTime: {
            Hours: 10,
            Minutes: 30,
            Seconds: 0,
            Milliseconds: 0,
            Ticks: 378000000000,
            Days: 0,
            TotalDays: 0.4375,
            TotalHours: 10.5,
            TotalMilliseconds: 37800000,
            TotalMinutes: 630,
            TotalSeconds: 37800,
        },
        TourInventoryAllocatedSeats: 10,
        TourTime: '10:30 AM',
        ShipName: 'Carnival Spirit',
        TourName: 'Chilkoot Horseback Adventure',
        PreLim: 10,
        Final: null,
        ActualTotal: null,
        ActualAdults: null,
        ActualChildren: null,
        CruiseLineEscorts: null,
        Transportation: null,
        GuideName: null,
        GuideFullName: null,
        DockName: null,
        DTDAssignmentGuideVariableId: null,
        DTDAssignmentGuideId: null,
        PayingAdditionalGuests: 0,
        SpecialNotes: null,
        BookingFName: null,
        BookingLName: null,
        BookingAdults: 0,
        BookingChildren: 0,
        BookingEmail: null,
        BookingPhone: null,
        PartnerId: null,
        TotalBooked: null,
        IsClosed: false,
        IsOpen: false,
        MobleViewColumn: null,
        Total: null,
    },
    {
        CompanyName: 'Alaska X',
        TourInventoryID: 13181,
        TourInventoryTime: {
            Hours: 13,
            Minutes: 0,
            Seconds: 0,
            Milliseconds: 0,
            Ticks: 468000000000,
            Days: 0,
            TotalDays: 0.5416666666666666,
            TotalHours: 13,
            TotalMilliseconds: 46800000,
            TotalMinutes: 780,
            TotalSeconds: 46800,
        },
        TourInventoryAllocatedSeats: 10,
        TourTime: '01:00 PM',
        ShipName: 'Ruby Princess',
        TourName: 'Chilkoot Horseback Adventure',
        PreLim: 4,
        Final: null,
        ActualTotal: null,
        ActualAdults: null,
        ActualChildren: null,
        CruiseLineEscorts: null,
        Transportation: null,
        GuideName: null,
        GuideFullName: null,
        DockName: null,
        DTDAssignmentGuideVariableId: null,
        DTDAssignmentGuideId: null,
        PayingAdditionalGuests: 0,
        SpecialNotes: null,
        BookingFName: null,
        BookingLName: null,
        BookingAdults: 0,
        BookingChildren: 0,
        BookingEmail: null,
        BookingPhone: null,
        PartnerId: null,
        TotalBooked: null,
        IsClosed: false,
        IsOpen: false,
        MobleViewColumn: null,
        Total: null,
    },
];
